import React, { Component } from 'react';

class BigTop extends Component {
  render() {
    return (
      <div>
        <div className="gm-slide__flashline">{ this.props.flashline }</div>
        <hr />
        <div className="gm-slide__intro-title">{ this.props.headline }</div>
        <div className="gm-slide__intro-dek">{ this.props.dek }</div>
      </div>
    )
  }
}

export default BigTop;



// WEBPACK FOOTER //
// ./src/components/Shared/BigTop.js